import { render, staticRenderFns } from "./AddDailyCashierReport.vue?vue&type=template&id=2484e6ae&"
import script from "./AddDailyCashierReport.vue?vue&type=script&lang=js&"
export * from "./AddDailyCashierReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports